import { render, staticRenderFns } from "./MovementRule.vue?vue&type=template&id=794a7345&scoped=true&"
import script from "./MovementRule.vue?vue&type=script&lang=js&"
export * from "./MovementRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a7345",
  null
  
)

export default component.exports